import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const GenericGuideSectionTitle = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-section-title' id={props.iContent.sectionName?.value}>
            {props.iContent.title?.value}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideSectionTitle);